<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import Header from '@/components/header/index'
import request from '@/service/request';
import { getProjectDetails } from '@/service/api'
import FloorInfo from "@/components/floorInfo.vue";
import {uniqueArray, uniqueFloor} from "@/tool/array";
import {rentPriceFormat, vacancyRate, warehouseArea} from "../../tool/number";

const compareMain = ref(null);
const tableBody = ref(null);
const header = ref(null);
let top = ref(0);
let height = ref(0);
let isShowFocus = ref(false);
let isFixed = ref(false);
let pn = null;
let compareListFramework = ref([
    // {key: "address", name:"地址", values:[]},
    {key: "projectDeveloper", name:"开发商", values:[]},
    // {key: "landProperty", name:"土地性质", values:[]},
    {key: "landUse", name:"土地性质", values:[]},
    {key: "buildingState", name:"建成状态", values:[]},
    {key: "maxBuiltTime", name:"建成时间", values:[]},
    {key: "areaTotal", name:"建成面积", values:[], unit: '（㎡）'},
    {key: "rptBuildingTypeNames", name:"建筑类型", values:[]},
    {key: "floorNumber", name:"层数", values:[]},
    {key: "floorHeight", name:"净高", values:[], unit: '（m）'},
    {key: "dischargeCargo", name:"卸货", values:[]},
    {key: "fireLevel", name:"防火等级", values:[]},
    {key: "platformType", name:"月台类型", values:[]},
    {key: "bearing", name:"承重", values:[], unit: '（t/㎡）'},
    {key: "awningDimension", name:"雨棚深度", values:[], unit: '（m）'},
    {key: "totalArea", name:"仓库总面积", values:[],unit: '（㎡）', tips: '包含建成面积和在建面积'},
    // {key: "price", name:"报价", values:[], unit: '（元/㎡·月）'},
    {key: "effectiveRent", name:"预估有效租金", values:[], unit: '（元/㎡·月）', tips: '折算免租期、装修期后的租金'},
    {key: "vacancyRate", name:"空置率", values:[], suffix: '%'}
])
const detailInfos=[]
const extraFloorHeight = (index) =>{
  let arr = (detailInfos[index] || []);
  return uniqueFloor(arr, (o) => ({key: o.floornumber, value: o.floorheight}))
}

const extraFloorBearing = (index) =>{
  let arr = (detailInfos[index] || []);
  return uniqueFloor(arr, (o) => ({key: o.floornumber, value: o.bearing}))
}

const maxFloorBearing = (index) => {
  return extraFloorBearing(index).max;
}

const maxFloorHeight = (index) =>{
  return extraFloorHeight(index).max;
}
function tableMoveHandler(e) {
    let dom = e.target;
    if (dom.tagName == 'SPAN') {
        if (pn) {
            pn.removeAttribute('style');
        }
        let currentPn = dom.parentNode.parentNode;
        top.value = currentPn.offsetTop + 'px';
        isShowFocus.value = true;
        pn = currentPn;
        // pn.style.fontWeight = 'bold';
        nextTick(() => {
            height.value = currentPn.offsetHeight + 'px';
        })
    }
}

function tableMouseOutHandler(e) {
    if (!tableBody.value.contains(e.toElement)) {
        isShowFocus.value = false;
        if (pn) {
            pn.removeAttribute('style');
        }
        pn = null;
    }
}

function fixedHeader(e) {
    const DISTANCE = 20; //.u-cp-box padding-top的距离
    let scrollTop = e.target.scrollTop;
    if (scrollTop > DISTANCE) {
        isFixed.value = true;
        header.value.style.transform = `translateY(${scrollTop - DISTANCE}px)`
    } else {
        isFixed.value = false;
    }
}


let campareList = ref([]);

// 获取对比数据列表
async function getCampareList(){
  let localList = localStorage.getItem("campareList");
  let list = localList ? JSON.parse(localList) : [];
  campareList.value = list.filter(item => item);
  const quarter = localStorage.getItem('mapTime') ? localStorage.getItem('mapTime') : '2023 Q3';


  let params = list.map(item => item.rptId);

  if(params.length === 0){
    campareList.value = [];
    return;
  }

  let result = await request({
    url: getProjectDetails,
    method: "post",
    data: {
      quarter,
      isHighBar: 1,
      ids: list.map(item => item.rptId)
    }
  })

  console.log('result.data', result.data);


  let fillArray = new Array(5 - campareList.value.length);
  let fillLen = fillArray.length;
  compareListFramework.value.forEach(item => {
    result.data.forEach(citem => {
      item.values.push({id:citem.rptId, value:citem[item.key]})
    })

    for(let i=0; i < fillLen; i++){
      item.values.push(null);
    }
  })
  result.data.forEach(citem => {
    detailInfos.push(citem.warehouseWeight);
  })

  let distances = list.reduce((p, c) => {
    let key = c.rptId;
    p[key] = c.distance;
    return p;
  }, {})

  console.log(distances)

  campareList.value = result.data;

  for(let i=0; i < fillLen; i++){
    campareList.value.push(null);
  }

  campareList.value.forEach(item => {
    if(item) item.distance = distances[item.rptId];
  })
}
onMounted(() => {
    getCampareList();
    compareMain.value.$el.addEventListener('scroll', fixedHeader);
})

onUnmounted(() => {
    compareMain.value.$el.removeEventListener('scroll', fixedHeader);
})
</script>
<style lang="less">
@import "../../assets/css/public.less";
@import "./index.less";
</style>
<style scoped lang="less">
.el-container {
    height: 100%;
    background: #F8F8F8;
    overflow: hidden;

    .el-header {
        height: 54px;
        background: #102451;
    }

    .el-main {
        padding: 0;
    }

}

.floor-info-show{
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 120px;
}
</style>

<template>
    <el-container>
        <el-header>
            <Header></Header>
        </el-header>

        <el-main ref="compareMain">
            <div class="u-agg-box" v-if="campareList.length > 0">
                <div class="u-cp-box">
                    <div class="u-cp-table">
                        <div class="u-cp-header fixed" ref="header" v-show="isFixed">
                            <div class="u-cp-header-pn">
                                <div class="u-cp-header-label" style="border-bottom: 1px solid #ddd;">项目名称</div>
                                <div class="u-cp-header-pname-list">
                                    <div class="u-cp-header-pname" v-for="(item,index) in campareList" :class="{[ `u-cp-hn-bg${index+1}`]: true}">{{item && item.projectName ? item.projectName : '-'}}</div>
                                </div>
                            </div>

                            <div class="u-cp-header-info">
                                <div class="u-cp-header-label">地址</div>
                                <div class="u-cp-header-project">
                                    <div class="ic-cp-hp-item" v-for="(item,index) in campareList" :key="index">
                                        <div class="u-cp-header-content-child" style="text-align: center;">
                                            <p v-if="item && item.distance">距目标园区{{item.distance}}米</p>
                                            <span>{{ item && item.address ? item.city + item.area + item.address : '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="u-cp-header">
                            <div class="u-cp-header-pn">
                                <div class="u-cp-header-label"  style="border-bottom: 1px solid #ddd;">项目名称</div>
                                <div class="u-cp-header-pname-list">
                                    <div v-for="(item,index) in campareList" class="u-cp-header-pname" :class="{[ `u-cp-hn-bg${index+1}`]: true}">
                                      {{item && item.projectName ? item.projectName : '-'}}
                                    </div>
                                </div>
                            </div>

                            <div class="u-cp-header-info">
                                <div class="u-cp-header-label">地址</div>
                                <div class="u-cp-header-project">
                                    <div class="ic-cp-hp-item"  v-for="(item,index) in campareList" :key="index">
                                        <div class="u-cp-header-content-child" style="text-align: center;">
                                            <p v-if="item && item.distance">距目标园区{{item.distance}}米</p>
                                            <span>{{ item && item.address ? item.city + item.area + item.address : '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="u-cp-body" @mousemove="tableMoveHandler" @mouseout="tableMouseOutHandler"
                            ref="tableBody">
                            <div class="u-cp-target-line" :style="{ 'left': 0, 'top': top, 'height': height }"
                                v-show="isShowFocus"></div>

                            <div class="u-cp-body-item" v-for="item in compareListFramework">
                                <div class="u-cp-body-label">
                                    <span>
                                      {{ item.name ? `${item.name}${item.unit?item.unit:''}`: '-' }}
                                      <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 icon-tips" v-if="item.tips" :title="item.tips" style="font-size:12px; width: 12px;height: 12px; position: relative; top: -6px;"></i>
                                    </span>
                                </div>
                                <div class="u-cp-body-content">
                                    <span class="compare-item" v-for="(citem,index) in item.values">
                                      <p v-if="item.key==='floorHeight'" class="floor-info-show">
                                        {{maxFloorHeight(index) || '-'}}
                                        <floor-info :extra="extraFloorHeight(index)" style="right:0;top:0;"></floor-info>
                                      </p>
                                      <p  v-else-if="item.key==='bearing'" class="floor-info-show">
                                        {{maxFloorBearing(index) || '-'}}
                                        <floor-info :extra="extraFloorBearing(index)" style="right:0;top:0;"></floor-info>
                                      </p>
                                      <p v-else-if="item&&item.key==='maxBuiltTime'">{{citem && citem.value ?new Date(citem.value).format('yyyy年MM月'):'-'}}</p>
                                      <p v-else-if="item&&(item.key==='totalArea' || item.key==='areaTotal')">{{warehouseArea(citem ? citem.value : null)}}</p>
                                      <p v-else-if="item&&item.key==='vacancyRate'">{{vacancyRate(citem ? citem.value : null)}}</p>
                                      <p v-else-if="item&&(item.key==='effectiveRent'||item.key==='price') ">{{rentPriceFormat(citem ? citem.value : null)}}</p>
                                      <p v-else>{{citem?citem.value:'-'}}</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="camprea-no-data" v-else>暂无对比数据</div>
        </el-main>
    </el-container>
</template>

